import React from 'react';

const Benefits = () => {
  const benefits = [
    {
      title: 'Transparente Beratung, ehrlich gerechnet',
      description: 'Die Beratung ist für Sie kostenfrei, meine Konditionen lege ich offen, bevor Sie entscheiden. Sie bekommen eine belegbare Einschätzung Ihres Einsparpotenzials, auf Basis vertraglich vereinbarter, messbarer Ziele — nicht auf Basis von Hochrechnungen.'
    },
    {
      title: 'Beratung und Umsetzung aus einer Hand',
      description: 'Andere beraten und übergeben. Ich begleite die Umstellung selbst, bis alles stabil läuft. Kein Bruch zwischen Konzept und Realität, kein Wechsel des Ansprechpartners, wenn es operativ wird.'
    },
    {
      title: '15+ Jahre operative Erfahrung',
      description: 'Ich kenne die Postprozesse großer Organisationen aus der Praxis: Portoklassen, Frankier-Strukturen, Standort-Chaos. Diese Detailtiefe entscheidet darüber, ob eine Umstellung reibungslos läuft oder das Tagesgeschäft gefährdet.'
    }
  ];

  return (
    <section className="py-20 lg:py-32 bg-slate-50 relative overflow-hidden">
      {/* Subtle background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-slate-100 rounded-full blur-3xl opacity-30"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-50 rounded-full blur-3xl opacity-20"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-12 text-center">
            Warum mit mir arbeiten
          </h2>
          
          <div className="space-y-6">
            {benefits.map((benefit, index) => (
              <div 
                key={index} 
                className="bg-white/80 backdrop-blur-sm p-8 rounded-lg border border-slate-200 hover:border-slate-300 hover:shadow-xl transition-all duration-300 group relative overflow-hidden"
              >
                {/* Subtle hover effect background */}
                <div className="absolute inset-0 bg-gradient-to-r from-slate-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                <div className="relative z-10">
                  <h3 className="text-xl font-semibold text-slate-900 mb-3 group-hover:text-slate-800 transition-colors">
                    {benefit.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed group-hover:text-slate-700 transition-colors">
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;